import { ACTIONS_ACTIVITY } from '../_constants/activity.constants';

// NOTE: This needs to be normalised futher. childActivities,
// activityClass and activitySubClass should be broken out.
const initialState = {
  byId: {},
};

export function activityReducer(state = initialState, action) {
  switch (action.type) {
    case ACTIONS_ACTIVITY.INVALIDATE: {
      return {
        ...initialState,
      };
    }

    case ACTIONS_ACTIVITY.DELETE: {
      const currentById = { ...state.byId };
      delete currentById[Object.keys(action.byId)[0]];

      return {
        ...state,
        byId: currentById,
      };
    }

    case ACTIONS_ACTIVITY.RECEIVE: {
      return {
        ...state,
        byId: { ...state.byId, ...action.byId },
      };
    }

    default:
      return state;
  }
}

export default activityReducer;
